import { Component, OnInit } from "@angular/core";

import * as moment from "moment";
import { EixoHasProponenteCadastradaFiltro } from "../../../core/services/edital-credenciamento/EixoHasProponenteCadastrada.service";
import { environment } from "../../../../environments/environment";
import { EditaisService } from "../editais.service";
import { ResultadoService } from "./resultado.service";

declare var $: any;

@Component({
  selector: "app-editais-timeline",
  templateUrl: "./editais-timeline.component.html",
  styleUrls: ["./editais-timeline.component.css"],
})
export class EditaisTimelineComponent implements OnInit {
  eixo = [];
  edital: any;
  url: any;
  parcial = [];
  resultados = [];

  btnReferencia: any;
  btnParcial: any;
  btnFinal: any;

  loading;

  moment = moment().format("YYYY-MM-DD");
  param: any;

  constructor(
    private resultadoService: ResultadoService,
    private editaisService: EditaisService
  ) {}

  public ngOnInit() {
    this.edital = JSON.parse(sessionStorage.getItem("Edital"));
    if (this.edital.termoReferenciaFileHash) {
      this.buscarPorCodigo(this.edital.id);
    }
  }

  buscarPorCodigo(codigo) {
    this.editaisService.buscarPorCodigo(codigo).then((EditalChamamento) => {
      this.edital = EditalChamamento;
    });

    // Subir ao topo
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      1000,
      "linear"
    );
  }

  goBack() {
    window.history.back();
  }

  accordion() {
    $(function () {
      $(".accordion")
        .find(".accordion__title")
        .click(function () {
          // Adds active class
          $(this).toggleClass("active");
          // Expand or collapse this panel
          $(this).next().slideToggle("fast");
          // Hide the other panels
          $(".accordion__content").not($(this).next()).slideUp("fast");
          // Removes active class from other titles
          $(".accordion__title").not($(this)).removeClass("active");
        });
    });
  }

  termodeReferencia() {
    var pdf = this.edital.termoReferenciaFileHash
      ? this.edital.termoReferenciaFileHash
      : this.edital.hashAnexo;
    this.url = environment.downloadFileUrl + `/${pdf}`;
  }

  clickIcone() {
    $("div").click(function () {
      $(this).find("i").toggleClass("fa-minus fa-plus");
      $(".content").toggleClass("active");
    });
  }

  resultadoParcial(param) {
    this.loading = false;
    this.resultadoService.resultadoParcial(param).then((dados) => {
      dados.sort(this.ordernaPorNota);
      this.resultados = dados;
      this.loading = true;
    });
  }

  ordernaPorNota(a, b) {
    return b.notaFinal - a.notaFinal;
  }

  onload() {
    $(document).ready(function () {
      $(".btn-theme").click(function () {
        $("#aguarde, #blanket").css("display", "block");
      });
    });
  }

  verificaResultadoFinal(objeto) {
    let retorno;
    if (objeto.id == 378) {
      retorno = "Eliminada";
    } else if (
      objeto.notaFinalAposRecurso >= this.edital.notaCorte &&
      !objeto.statusDesclassif
    ) {
      retorno = "Classificada";
    } else {
      retorno = "Eliminada";
    }
    return retorno;
  }

  verificaResultadoParcial(objeto) {
    let retorno;
    if (objeto.id == 378) {
      retorno = "Eliminada";
    } else if (
      objeto.notaFinal >= this.edital.notaCorte &&
      !objeto.statusDesclassif
    ) {
      retorno = "Classificada";
    } else {
      retorno = "Eliminada";
    }
    return retorno;
  }

  pesquisarResultadoPacialCredenciamento(tipo, eixoPrograma) {
    this.resultadoService
      .pesquisarResultadoCredenciamento(tipo, eixoPrograma)
      .then((dados) => {
        this.resultados = dados;
        this.loading = true;
      });
  }
}
